import React from 'react';

const IconDownTriangle = (rest) => {
	return (
		<svg
			width='12'
			height='7'
			viewBox='0 0 12 7'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 0.268555L6 6.26855L12 0.268555L0 0.268555Z'
				fill='#767676'
			/>
		</svg>
	);
};

export default IconDownTriangle;
